export default "__VITE_ASSET__BLHcLdUT__"